import { useState } from "react";
import { useSelector } from "react-redux";
import DeleteModal from "../../../common/DeleteModal";
import NotificationService from "../../../../services/NotificationService";
import trashIcon from "../../../../images/icons/delete.svg";
import eye from "../../../../images/icons/eye.svg";
import { useNavigate } from "react-router-dom";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.roles?.includes(data);
	const notificationService = new NotificationService();

	return (
		<tr key={index} className="text-center">
			<td>{lang === "en" ? item.massage_title_en : item.massage_title_ar}</td>
			{/* <td>{lang === "en" ? item.massage_body_en : item.massage_body_ar}</td> */}
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					<img
						src={eye}
						onClick={() =>
							navigate("/notification/add-notification", { state: item })
						}
						className="cursor-pointer"
						alt="edit"
						width={24}
					/>
					{isExist("delete_notifications") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>

			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={
						lang === "en" ? item.massage_title_en : item.massage_title_ar
					}
					deletedItem={item}
					modelService={notificationService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
